import { Box, Container, Grid, Header } from '@amzn/awsui-components-core';
import { useFinTechContext } from 'src/components/context/FintechContextProvider';
import { FinOpsTable } from 'src/components/fintech-ops/fintech-ops-table/FinOpsTable';
import { LoadingSpinner } from 'src/components/generic-components/LoadingSpinner';
import { ErrorContainer, NotInitializedContainer } from '../FinTechOpsCommonElements';
import { useSasContext } from './SasContext';
import React from 'react';
import { numberFormatter } from 'src/utilities/CommonUtilities';
import styles from './styles.module.scss';

export const SasDetailsTab: React.FC = () => {
  const finOpsContext = useFinTechContext();
  const sasContext = useSasContext();

  return (
    <div>
      {finOpsContext.finTechOpsSasDataStatus == 'loading' && <LoadingSpinner />}
      {finOpsContext.finTechOpsSasDataStatus == 'pending' && <NotInitializedContainer />}
      {finOpsContext.finTechOpsSasDataStatus == 'error' && <ErrorContainer />}
      {finOpsContext.finTechOpsSasDataStatus == 'finished' && (
        <Grid
          gridDefinition={[
            { colspan: { default: 12, xxs: 12, xs: 12, s: 12, m: 3, l: 3, xl: 3 } },
            { colspan: { default: 12, xxs: 12, xs: 12, s: 12, m: 9, l: 9, xl: 9 } },
            { colspan: { default: 12, xxs: 12, xs: 12, s: 12, m: 12, l: 12, xl: 12 } },
            { colspan: { default: 12, xxs: 12, xs: 12, s: 12, m: 12, l: 12, xl: 12 } },
            { colspan: { default: 12, xxs: 12, xs: 12, s: 12, m: 12, l: 12, xl: 12 } }
          ]}
        >
          <Container fitHeight header={<Header variant="h2">Total Open Risks</Header>}>
            <Box variant="h3" textAlign="center">
              {numberFormatter(sasContext.sasSummaryContainer.totalOpenRisks)}
            </Box>
            <div className={styles.UserMetricsFootPrintContainerTable}>
              <FinOpsTable
                pageSize={5}
                emptyMessage="No SAS data to display"
                filterProperties={[]}
                visibleContent={sasContext.sasSummaryContainer.totalRisksByTeam.visibleColumns}
                columnDefinitions={sasContext.sasSummaryContainer.totalRisksByTeam.columnData}
                data={sasContext.sasSummaryContainer.totalRisksByTeam.rowData}
                headerName=""
              />
            </div>
          </Container>
          <Container fitHeight>
            <FinOpsTable
              pageSize={8}
              stickyHeader={false}
              emptyMessage="No SAS data to display"
              filterProperties={[]}
              visibleContent={sasContext.sasTotalRiskResourceTableData.visibleColumns}
              columnDefinitions={sasContext.sasTotalRiskResourceTableData.columnData}
              data={sasContext.sasTotalRiskResourceTableData.rowData}
              headerName="Total Open Risk by Resource Type and Team"
            />
          </Container>
          <Container fitHeight>
            <FinOpsTable
              pageSize={6}
              emptyMessage="No SAS data to display"
              filterProperties={[]}
              visibleContent={sasContext.sasDetailsTableData.visibleColumns}
              columnDefinitions={sasContext.sasDetailsTableData.columnData}
              data={sasContext.sasDetailsTableData.rowData}
              headerName="Total Risks Breakout By Team Managers"
            />
          </Container>
          <Container fitHeight>
            <FinOpsTable
              pageSize={6}
              emptyMessage="No SAS data to display"
              filterProperties={[]}
              visibleContent={sasContext.sasManagerMomTableData.visibleColumns}
              columnDefinitions={sasContext.sasManagerMomTableData.columnData}
              data={sasContext.sasManagerMomTableData.rowData}
              headerName="Aggregated Risks by Team Managers"
            />
          </Container>
          <Container>
            <FinOpsTable
              pageSize={10}
              emptyMessage="No SAS data to display"
              filterProperties={[]}
              visibleContent={sasContext.sasOpenTotalRiskTableData.visibleColumns}
              columnDefinitions={sasContext.sasOpenTotalRiskTableData.columnData}
              data={sasContext.sasOpenTotalRiskTableData.rowData}
              headerName="Total Open Risk's With Recommendation"
              enableDownloadReport={true}
              downloadFileName="Total_Open_Risks_With_Recommendation"
            />
          </Container>
        </Grid>
      )}
    </div>
  );
};
